export default {"src":"/_next/static/media/contact_us_banner.e4de1094.svg","height":276,"width":491,"blurWidth":0,"blurHeight":0};